<div>
    <h1 class="main-title">
        <div class="circle circle-primary">
            <img src="assets/icons/info-icon.svg" alt="">
        </div>
        Gráficos y Estadísticas
    </h1>
    <div class="flex justify-between items-center mb-2">
        <h2 class="main-subtitle">Mis Vistas Guardadas</h2>
    </div>

    <div class="single-page-content">
        <div class="grid grid-cols-1 xl:grid-cols-3 2xl:grid-cols-4 gap-4 mb-4">
            <app-multiple-select [label]=" 'Tipo de envase' " [items]="containerTypes" [ids]="filter.containerTypeIds"
                (selectionChange)="filter.containerTypeIds = $event"></app-multiple-select>

            <app-multiple-select [label]=" 'Estado de envases' " [items]="statuses" [ids]="filter.stateIds"
                (selectionChange)="filter.stateIds = $event"></app-multiple-select>

            <app-multiple-select [label]=" 'Propietario' " [items]="owners" [ids]="filter.ownerIds"
                (selectionChange)="filter.ownerIds = $event"></app-multiple-select>

            <app-multiple-select [label]=" 'Cliente' " [items]="clients" [ids]="filter.clientIds"
                (selectionChange)="filter.clientIds = $event"></app-multiple-select>

        </div>

        <div class="flex justify-end mb-8">
            <button class="button button-primary w-100 mr-2" (click)="getMaintenanceRecordStats()">
                Generar Informe
            </button>
            <button class="button button-primary w-100 mr-2" (click)="openSaveFilterModal()">
                Guardar Filtro
            </button>
            <button class="button button-primary w-100 mr-2" (click)="toggleSavedFilters()">
                Filtros Guardados
                <i matSuffix class="fa-solid fa-chevron-down text-xs transition-transform duration-300 ml-2"
                    [class.rotate-180]="showSavedFilters"></i>
            </button>
            <button class="button button-primary w-100" (click)="exportToExcel()" [disabled]="!dataSource || dataSource.length === 0">
                Exportar Excel
            </button>
        </div>

        <div *ngIf="showSavedFilters" class="grid grid-cols-1 xl:grid-cols-3 2xl:grid-cols-4 gap-4 mb-4">
            <div class="col-span-full bg-white shadow rounded-lg overflow-hidden border border-gray-200">
                <table mat-table [dataSource]="savedFiltersDataSource" class="w-full">

                    <ng-container matColumnDef="nombre">
                        <th mat-header-cell *matHeaderCellDef class="font-bold text-gray-700 col-nombre"> Nombre </th>
                        <td mat-cell *matCellDef="let filter" class="col-nombre"> {{ filter.name }} </td>
                    </ng-container>

                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef class="text-center font-bold text-gray-700 col-acciones">
                            Acciones </th>
                        <td mat-cell *matCellDef="let filter" class="text-center col-acciones">
                            <button mat-icon-button (click)="onApplyFilter(filter)" title="Aplicar"
                                class="btn-action-blue">
                                <mat-icon>play_arrow</mat-icon>
                            </button>
                            <button mat-icon-button (click)="openDeleteModal(filter)" title="Eliminar"
                                class="btn-action-blue">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="['nombre', 'acciones']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['nombre', 'acciones'];"></tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell p-4 text-center" colspan="2">No tienes filtros guardados.</td>
                    </tr>
                </table>
            </div>
        </div>

        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
            <!-- Columna fija: Tipo de Envase -->
            <ng-container matColumnDef="containerType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo de Envase </th>
                <td mat-cell *matCellDef="let data"> {{data.containerType.name}} </td>
            </ng-container>

            <!-- Columnas dinámicas: Estados -->
            <ng-container *ngFor="let state of states" [matColumnDef]="'state_' + state.id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{state.name}} </th>
                <td mat-cell *matCellDef="let data" (click)="onCellClick(data.containerType, state)"
                    style="cursor: pointer;">
                    {{getTotalForState(data, state.id)}}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
</div>




<div *ngIf="showSaveFilterModal === true" class="modal startShift-modal" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title text-primary-500">Guardar filtro</h4>
                <button (click)="closeModals()" type="button" class="close" aria-label="Close">X </button>
            </div>
            <div *ngIf="!successSaveFilter" class="modal-body text-center">
                @if(isSomeFilterSelected()){
                <p>Ingrese nombre para filtro</p>
                <form [formGroup]="filterNameForm">
                    <div class="mb-4">
                        <mat-form-field appearance="fill" class="w-full">
                            <mat-label>Nombre del filtro</mat-label>
                            <input matInput formControlName="name" placeholder="Ej: Filtro de exportación mensual 2025"
                                autocomplete="off">

                            <mat-error *ngIf="filterNameForm.get('name')?.hasError('minlength')">
                                Debe tener al menos <strong>{{minLengthFilterName}} caracteres</strong>
                            </mat-error>
                            <mat-error *ngIf="filterNameForm.get('name')?.hasError('maxlength')">
                                Debe tener menos de <strong>100 caracteres</strong>
                            </mat-error>
                            <mat-error *ngIf="filterNameForm.get('name')?.hasError('required')">
                                El nombre es obligatorio.
                            </mat-error>
                            <mat-error *ngIf="filterNameForm.get('name')?.hasError('duplicateName')">
                                Este nombre ya ha sido usado en otro filtro.
                            </mat-error>
                        </mat-form-field>
                    </div>
                </form>
                }@else{
                <p>Debe seleccioar al menos un filtro para guardar</p>}

            </div>

            <div *ngIf="successSaveFilter" class="modal-body text-center">
                <p>Filtro guardado con exito</p>
            </div>

            <div class="modal-footer">
                <button *ngIf="!successSaveFilter" type="button" class="button button-outlined-primary button-sm mr-2"
                    (click)="closeModals()">Cancelar</button>
                <button *ngIf="!successSaveFilter && isSomeFilterSelected()" type="button"
                    class="button button-success button-sm" (click)="onSaveFilter()">Guardar</button>
                <button *ngIf="successSaveFilter" type="button" class="button button-success button-sm"
                    (click)="closeModals()">Aceptar</button>

            </div>
        </div>
    </div>
</div>

<div *ngIf="showErrorModal" class="modal startShift-modal" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title text-primary-500">Guardar filtro</h4>
                <button (click)="closeModals()" type="button" class="close" aria-label="Close">X </button>
            </div>
            <div class="modal-body text-center">
                <p>No puede tener mas de 10 filtros guardados</p>
                <small>Elimine algun filtro antes de continuar</small>
            </div>

            <div class="modal-footer">
                <button type="button" class="button button-success button-sm" (click)="closeModals()">Aceptar</button>
            </div>
        </div>
    </div>
</div>


<div *ngIf="showConfirmDeleteModal" class="modal startShift-modal" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title text-primary-500">Eliminar filtro</h4>
                <button (click)="closeModals()" type="button" class="close" aria-label="Close">X</button>
            </div>

            <div class="modal-body text-center">
                @if(!successDeleteFilter){
                <p>¿Desea eliminar el filtro?</p>
                }@else {
                <p>Filtro eliminado con exito</p>
                }
            </div>

            <div class="modal-footer">
                @if(!successDeleteFilter){
                <button type="button" class="button button-outlined-primary button-sm mr-2"
                    (click)="closeModals()">Cancelar</button>
                <button type="button" class="button button-success button-sm" (click)="onDelete()">Si, eliminar</button>
                }@else {
                <button type="button" class="button button-success button-sm" (click)="closeModals()">Aceptar</button>
                }


            </div>
        </div>
    </div>
</div>